function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var fqhc = function fqhc(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 39V10.4815L20 1.11491L39 10.4815V39H1Z",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.0457L22.347 18.7978L22.5755 19.4551L23.2712 19.4693L30.4181 19.6149L24.7218 23.9336L24.1673 24.354L24.3688 25.0201L26.4388 31.8622L20.5712 27.7792L20 27.3817L19.4288 27.7792L13.5612 31.8622L15.6312 25.0201L15.8327 24.354L15.2782 23.9336L9.58186 19.6149L16.7288 19.4693L17.4245 19.4551L17.653 18.7978L20 12.0457Z",
    stroke: "black",
    strokeWidth: "2"
  }));
};

export default fqhc;